import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue } from "bootstrap-vue";
import axios from "axios";

import store from "@/store";
import router from "@/router";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./style.scss";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSearch,
  faShoppingCart,
  faCheck,
  faShoppingBasket,
  faTimes,
  faLock,
  faTrash,
  faPlus,
  faMinus,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {getStoreConfig} from "./config";

const storeConfig = getStoreConfig();

const root = document.documentElement;
document.body.classList.add(storeConfig.name);
document.querySelector('title').textContent = storeConfig.title;
axios.defaults.baseURL = storeConfig.apiUrl;
root.style.setProperty('--main-color', storeConfig.theme.main);
root.style.setProperty('--main-color-dark', storeConfig.theme.dark);

Vue.use(BootstrapVue);
Vue.use(axios);
Vue.component("font", FontAwesomeIcon);

library.add(
  faSearch,
  faShoppingCart,
  faCheck,
  faShoppingBasket,
  faTimes,
  faLock,
  faTrash,
  faPlus,
  faMinus,
  faFacebook,
  faArrowRight
);

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
